export default __webpack_public_path__ + "static/media/music_popup_four.df2769f5.png";